import { render, staticRenderFns } from "./PhoneConfirmButton.vue?vue&type=template&id=60d44a53"
import script from "./PhoneConfirmButton.vue?vue&type=script&lang=js"
export * from "./PhoneConfirmButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports